// extracted by mini-css-extract-plugin
export default {"prompt":"fPuVi_SMnzbZE4Bujhpc","toggleContainer":"ZyX2sbx5gQJtyqz3moE5","commentPrompt":"KSVi3RNG_e6UMCDlJoTP","buttons":"m5gqNv9YKwxOZhWabKI6"};